//import update from 'immutability-helper';

const emptyState = {
  pathname: "",
  query: {},
  title: null,
  message: null
}

const DialogConfirmReducer = (state = emptyState, action) => {
  switch (action.type) {
    case "DIALOGCONFIRM_CHANGE_INPUT_VALUE" : {
      let { name, value } = action.payload;
      return {...state, [name]: value};
    }
    case "OPEN_OVERLAY": {
      let { dialog, params } = action.payload;
      if (dialog === "confirm") {
        let { pathname, query, title, message } = params;
        let newQuery = JSON.parse(JSON.stringify(query));
        
        return {...state, ...emptyState, pathname: pathname, query: newQuery, title: title, message: message };
      }

      // Empty everything if not selected
      return {};
    }
    case "CLOSE_OVERLAY": {
      // Empty everything if not selected
      return {};
    }
    default: {
      return state
    }
  }
}

export default DialogConfirmReducer